import { isPlainObject } from '@dimjs/lang';
import { toArray } from '@flatbiz/utils';
import { TModalSelectorDataItem, TModalSelectorRespItem, TModalSelectorValue } from './types';

export const parseInputValue = (value?: TModalSelectorValue, multiple?: boolean) => {
  const tempValues = toArray(value);
  if (tempValues.length === 0) return [];
  const values = tempValues
    .map((item) => {
      return isPlainObject(item) ? item?.['value'] : item;
    })
    .filter(Boolean) as Array<string | number>;
  return multiple ? values : [values[0]];
};

export const getModalSelectorRespData = (
  value: TModalSelectorValue,
  dataSource: TModalSelectorDataItem[],
  multiple?: boolean,
) => {
  const values = toArray(value);
  if (values.length === 0) {
    return undefined;
  }
  if (multiple) {
    const labelList = [] as string[];
    const valueList = [] as TModalSelectorDataItem[];
    values.forEach((value) => {
      const target = dataSource.find((item) => item.value === value);
      if (target) {
        labelList.push(target.label);
        const tempData: TModalSelectorDataItem = { value: target.value, label: target.label };
        if (target.extraData) {
          tempData.extraData = target.extraData;
        }
        valueList.push(tempData);
      }
    });
    return {
      label: labelList.join('-'),
      value: valueList,
    } as TModalSelectorRespItem;
  } else {
    const target = dataSource.find((item) => item.value === values[0]);
    if (target) {
      const tempData: TModalSelectorDataItem = { value: target.value, label: target.label };
      if (target.extraData) {
        tempData.extraData = target.extraData;
      }
      return tempData as TModalSelectorRespItem;
    }
  }
  return undefined;
};
